import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule, MatButtonModule, MatProgressBarModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatTooltipModule, MatCardModule } from '@angular/material';

import { EnfermeiroRoutingModule } from './enfermeiro-routing.module';
import { SharedModule } from 'app/shared/shared.module';
import { CalendarModule } from 'app/shared/components/calendario/calendar.module';

import { PipeModule } from 'app/core/pipes/pipes.module';
import { CoreModule } from 'app/core/core.module';

import { EnfermeiroAlterarCartaoGestanteComponent } from './subpages/enfermeiro-alterar-cartao-gestante/enfermeiro-alterar-cartao-gestante.component';
import { EnfermeiroAlterarPacienteComponent } from './subpages/enfermeiro-alterar-paciente/enfermeiro-alterar-paciente.component';
import { EnfermeiroCadastrarPacienteComponent } from './subpages/enfermeiro-cadastrar-paciente/enfermeiro-cadastrar-paciente.component';
import { EnfermeiroEditarPerfilComponent } from './subpages/enfermeiro-editar-perfil/enfermeiro-editar-perfil.component';
import { EnfermeiroEncerrarCartaoComponent } from './subpages/enfermeiro-encerrar-cartao/enfermeiro-encerrar-cartao.component';
import { EnfermeiroPacientesComponent } from './subpages/enfermeiro-pacientes/enfermeiro-pacientes.component';
import { EnfermeiroSecretariasComponent } from './subpages/enfermeiro-secretarias/enfermeiro-secretarias.component';
import { ModalAdicionarExameComponent } from './components/modal-adicionar-exame/modal-adicionar-exame.component';
import { ModalConsultasDiariaComponent } from './components/modal-consultas-diaria/modal-consultas-diaria.component';

import { RbFabSpeedDialModule } from 'rb-fab-speed-dial';

@NgModule({
    declarations: [
        EnfermeiroPacientesComponent, 
        EnfermeiroCadastrarPacienteComponent, 
        EnfermeiroEditarPerfilComponent, 
        EnfermeiroAlterarPacienteComponent, 
        EnfermeiroAlterarCartaoGestanteComponent, 
        ModalConsultasDiariaComponent, 
        ModalAdicionarExameComponent, 
        EnfermeiroEncerrarCartaoComponent, 
        EnfermeiroSecretariasComponent
    ],

    imports: [
        CommonModule,
        EnfermeiroRoutingModule,
        SharedModule,
        CalendarModule,
        CoreModule,
        PipeModule,

        /** FormsModule */
        FormsModule,
        ReactiveFormsModule,

        RbFabSpeedDialModule,

        /** Angular material */
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatProgressBarModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatCardModule,
    ],

    entryComponents: [
        ModalConsultasDiariaComponent,
        ModalAdicionarExameComponent,
        EnfermeiroEncerrarCartaoComponent
    ]
})
export class EnfermeiroModule { }
